import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'

interface GetArtifactSourceResponse {
  html?: string
}

// The widget's raw HTML source, for a reviewer to read the code before
// approving. Reviewer-only + own-org on the server.
const getArtifactSource = async (publicId: string): Promise<string> => {
  const response = await forgeApi.get<GetArtifactSourceResponse>(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/source`
  )
  return response.data.html ?? ''
}

const ARTIFACT_SOURCE_QUERY_KEY = 'forge-artifact-source'

export const useArtifactSourceQuery = (
  publicId: string,
  options?: ExtendableQueryOptions<string>
) =>
  useQuery({
    queryKey: [ARTIFACT_SOURCE_QUERY_KEY, publicId],
    queryFn: () => getArtifactSource(publicId),
    ...options
  })
